export const relationshipTypes = [
  {id: 'OWNER', name: 'Owner', description: 'Property owner', industries: ['levies']},
  {id: 'SPOUSE', name: 'Spouse', description: 'Married partner', industries: ['school', 'medical', 'levies']},
  {id: 'CHILD', name: 'Child', description: 'Son or daughter', industries: ['school', 'medical']},
  {id: 'RELATIVE', name: 'Relative', description: 'Family member', industries: ['school', 'medical']},
  {id: 'MOTHER', name: 'Mother', description: 'Biological or adoptive mother', industries: ['school', 'medical']},
  {id: 'FATHER', name: 'Father', description: 'Biological or adoptive father', industries: ['school', 'medical']},
  {id: 'FRIEND', name: 'Friend', description: 'Personal friend', industries: ['school', 'medical']},

  {id: 'TENANT', name: 'Tenant', description: 'Renting the property', industries: ['levies']},
  {id: 'CARETAKER', name: 'Cabin Master', description: 'Property caretaker', industries: ['levies']},
  {id: 'HOUSEKEEPER', name: 'House Keeper', description: 'Domestic worker', industries: ['levies']},
  {id: 'GARDENER', name: 'Gardener', description: 'Garden maintenance', industries: ['levies']},
  {id: 'SECURITY', name: 'Security', description: 'Security personnel', industries: ['levies']},

  {id: 'EMERGENCY_CONTACT', name: 'Emergency Contact', description: 'Person to contact in emergencies', industries: ['commerce', 'levies', 'school', 'medical']},
  {id: 'REFERRING_PHYSICIAN', name: 'Referring Physician', description: 'Doctor who referred the patient', industries: ['medical']},
  {id: 'GUARDIAN', name: 'Guardian', description: 'Legal guardian', industries: ['school']},

  { 
    id: 'OTHER',
    name: 'Other',
    description: 'Other relationship type',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor', 'fastatext']
  }
];



// WEBPACK FOOTER //
// ./src/utils/relationship.types.js